import { render, staticRenderFns } from "./APIManage.vue?vue&type=template&id=1f31a66f&scoped=true&"
import script from "./APIManage.vue?vue&type=script&lang=js&"
export * from "./APIManage.vue?vue&type=script&lang=js&"
import style0 from "./APIManage.vue?vue&type=style&index=0&id=1f31a66f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f31a66f",
  null
  
)

export default component.exports